import ApiService from "./api.service";

const ZetReportService = {
	getCurrentZReport(depId, cashboxId) {
		return ApiService.post(`/zet-report/get-current-z-report/${depId}/${cashboxId}`);
	},
	getCurrentXReport(depId, cashboxId) {
		return ApiService.post(`/zet-report/get-current-x-report/${depId}/${cashboxId}`);
	},
	/**
	 * 24.01.2020 DA BAXTIYOR VA MUZAFFAR TOMONIDAN QO'SHILDI GLOBAL(TASHKENT) DAGI ZREPORTLAR SUMMASI
	 * VA KASSIRLAR BERADIGAN SUMMA ORASIDA FARQLAR CHIQGANI SABABLI (FARQNING ASL SABABI SAVDOLAR O'Z VAQTIDA EMAS BOSHQA
	 * KUNLARDA RO'YXATGA OLINGANIDA BO'LIB CHIQDI)
	 * @param {zReportDocId} zReportId
	 * @param {departmentId} depId
	 */
	getZReportById(zReportIdAndDepId) {
		return ApiService.post(
			`/zet-report/z-report-by-id/${zReportIdAndDepId.zReportId}/${zReportIdAndDepId.depId}/${zReportIdAndDepId.cashboxId}`
		);
	},

	checkOpenZReport(depId, cashBoxId) {
		return ApiService.post(`/zet-report/check/open/${depId}/${cashBoxId}`)
	},

	openSession: function(id, cashboxId) {
		return ApiService.post(`/zet-report/open/${id}/${cashboxId}`);
	},

	getZReportByDepartmentId: function(id, cashboxId) {
		return ApiService.post(`/zet-report/get-z-report/${id}/${cashboxId}`);
	},

	getXReport: function(data, cashboxId) {
		return ApiService.post(`zet-report/get-x-report/${data}`);
	},

	getMonthlyXReport: function(cashboxId) {
		return ApiService.post(`/zet-report/get-x-report-month`);
	}
};

export default ZetReportService;
